module.exports = "https://cdn.schoolblocks.com/assets/_next/static/media/zip-c2648.png";